import React, { useState } from 'react';
import './DisputeTodo.scss';
import { FollowUpTodoType } from '../FollowUpTodo/FollowUpTodoType';
import AppButton from 'src/components/base/Button/Button';
import { updateIfollowedUpTodo } from 'src/redux/services/loggingServices';
import { useDispatch } from 'react-redux';
import { clearModalContent } from 'src/redux/modules/modalEvent';
import { useTranslation } from 'react-i18next';
import { setFlashNotification } from 'src/redux/modules/flashNotification';

interface DisputeTodoProps {
  todoId: string;
  todo: FollowUpTodoType;
  getUpdatedAuditLogs: () => void;
}

const DisputeTodo: React.FC<DisputeTodoProps> = ({
  todo,
  getUpdatedAuditLogs,
  todoId,
}) => {
  const [isRefundButtonProcessing, setIsRefundButtonProcessing] =
    useState<boolean>(false);
  const [isRejectButtonProcessing, setIsRejectButtonProcessing] =
    useState<boolean>(false);
  const dispatch = useDispatch();
  const { t } = useTranslation('components');

  const updateDisputeTodo = async (isRefundable: boolean) => {
    try {
      const respObj = {
        is_dispute_refundable: isRefundable,
      };

      await updateIfollowedUpTodo(todoId, respObj);
      dispatch(
        setFlashNotification({
          message: `${
            isRefundable
              ? t('disputeTodo.text.refund')
              : t('disputeTodo.text.reject')
          } ${t('disputeTodo.text.refundSuccess')}`,
        }),
      );
      dispatch(clearModalContent());
      getUpdatedAuditLogs();
    } catch (error: any) {
      dispatch(
        setFlashNotification({
          message:
            error?.message ||
            error?.response?.data?.message ||
            `${
              isRefundable
                ? t('disputeTodo.text.refund')
                : t('disputeTodo.text.reject')
            } ${t('disputeTodo.text.refundFailure')}`,
          isError: true,
        }),
      );
    } finally {
      setIsRefundButtonProcessing(false);
      setIsRejectButtonProcessing(false);
    }
  };

  const handleDisputeRefund = async () => {
    setIsRefundButtonProcessing(true);
    await updateDisputeTodo(true);
  };

  const handleRejectDispute = async () => {
    setIsRejectButtonProcessing(true);
    await updateDisputeTodo(false);
  };

  return (
    <div className="dispute-todo">
      <div>
        <span className="dispute-todo-span">
          {todo?.metadata?.provider_name}
        </span>{' '}
        {t('disputeTodo.text.requestedPayment')}{' '}
        <span className="dispute-todo-span">
          {todo?.metadata?.payment_amount} {t('disputeTodo.text.usd')}
        </span>{' '}
        {t('disputeTodo.text.at')}{' '}
        <span className="dispute-todo-span">{todo?.metadata?.charged_at}</span>{' '}
        {t('disputeTodo.text.forOnboardingClient')}{' '}
        <span className="dispute-todo-span">{todo?.metadata?.client_name}</span>
      </div>
      <div>
        <div>
          {' '}
          <span className="dispute-todo-span">
            {todo?.metadata?.provider_name}
          </span>{' '}
          {t('disputeTodo.text.hasGivenExplanation')}
        </div>
        <div>{todo?.metadata?.disputed_reason}</div>
      </div>
      <div>
        <span className="dispute-todo-span">
          {t('disputeTodo.text.refundPayment')}
        </span>
      </div>
      <div className="dispute-todo-btn">
        <div>
          <AppButton
            isProcessing={isRejectButtonProcessing}
            label={t('disputeTodo.text.reject')}
            onClick={handleRejectDispute}
            variant="secondary"
            className="dispute-todo-btn-reject"
          />
        </div>
        <div>
          <AppButton
            variant="danger"
            isProcessing={isRefundButtonProcessing}
            label={t('disputeTodo.text.refund')}
            onClick={handleDisputeRefund}
            className="dispute-todo-btn-refund"
          />
        </div>
      </div>
    </div>
  );
};

export default DisputeTodo;
